import { MarketsHeaderOptions } from '@om-fe/core/utils/config';

export const DEFAULT_MARKETS_HEADER_OPTIONS = MarketsHeaderOptions.SHOW_TOURNAMENT;
